//import axios from 'axios';

import request from '@/api/axiosFun'





export  const goods_list=()=>{
    return request({
            url:"goods/GetGoodsList",
            method:"post",
         //   data
        })
    }

export  const getdouyin=(data)=>{
        return request({
                url:"goods/ExportGoodsList",
                method:"post",
                data
            })
        }



// WEBPACK FOOTER //
// ./src/api/goods.js